import { render } from "./MyNotice.vue?vue&type=template&id=6f57b624&scoped=true"
import script from "./MyNotice.vue?vue&type=script&lang=js"
export * from "./MyNotice.vue?vue&type=script&lang=js"

import "./MyNotice.vue?vue&type=style&index=0&id=6f57b624&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f57b624"]])

export default __exports__